import AppHeader from "./app-header";
import AppFooter from "./app-footer";
import { Stack, useTheme } from "@mui/material";
import { Toaster } from "react-hot-toast";
import { useAuthStore } from "../../stores/authStore";

const AppLayout = ({ children }) => {
  const theme = useTheme();

  return (
    <Stack overflow="hidden" bgcolor={theme.palette.background.default}>
      <AppHeader />
      <Toaster />
      {children}
      <AppFooter />
    </Stack>
  );
};

export default AppLayout;
